query GetCharityCategories($page: Int, $limit: Int, $search: String) {
  charityCategories(page: $page, limit: $limit, search: $search) {
    collection {
      id
      name
      backgroundColour
      causeAreas
      icon
      excludeFromHifoSelection
      description
      exampleHifo {
        id
        name
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
